export default "__VITE_ASSET__47ce1192__"